import "./Header.css";
import { AuthContext } from "../services/authContext";
import { useContext } from "react";
import { Link } from "react-router-dom";

function Header() {
  const { authenticated } = useContext(AuthContext);

  return (
    <header className="header">
      <img src="./logo192.png" alt="Company Logo" className="logo" />
      <nav>
        <ul>
          {authenticated && (
            <div>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/Profile">Profile</Link>
              </li>
              <li>
                <Link to="/Logout">Logout</Link>
              </li>
            </div>
          )}
          {!authenticated && (
            <li>
              <Link to="/Login">Login</Link>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
